var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.toasts.length > 0)?_c('div',{staticClass:"toasts-wrapper"},_vm._l((_vm.toasts),function(t,index){return _c('Toast',{key:index,attrs:{"toast":t}})}),1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }